import { api } from "@/lib/axios";
import { Campaign as Region } from "@/types/project";

const get = (): Promise<Region[]> =>
    api.get("/regions").then((r) => r.data);

export default get;
